/* Bob Laadt Op — bob-spec-compare: specificatietabel in- en uitklappen
   (ontwerp: product-detailv2.html, JS 2390–2401).
   Teksten van de knop komen uit data-label-open / data-label-close (Liquid-settings).
   In de theme editor klapt de tabel open als je een verborgen rij selecteert. */

if (!customElements.get('bob-spec-compare')) {
  class BobSpecCompare extends HTMLElement {
    connectedCallback() {
      this.table = this.querySelector('.spec-table');
      this.toggle = this.querySelector('.spec-toggle');
      if (!this.table || !this.toggle) return;

      this.onClick = () => this.setOpen(this.table.classList.contains('is-collapsed'));
      this.toggle.addEventListener('click', this.onClick);

      /* Theme editor: geselecteerd rij-block dat verborgen is → tabel openklappen */
      this.onBlockSelect = (event) => {
        if (this.contains(event.target) && event.target.classList.contains('spec-row--extra')) {
          this.setOpen(true);
        }
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      if (this.toggle && this.onClick) this.toggle.removeEventListener('click', this.onClick);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    setOpen(open) {
      this.table.classList.toggle('is-collapsed', !open);
      this.toggle.setAttribute('aria-expanded', String(open));
      const label = this.toggle.querySelector('.spec-toggle-label');
      if (label) {
        label.textContent = open ? this.toggle.dataset.labelClose : this.toggle.dataset.labelOpen;
      }
    }
  }

  customElements.define('bob-spec-compare', BobSpecCompare);
}
